import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicOrderComponent } from './public-order/public-order.component';
import { StoreInvoiceComponent } from './store-invoice/store-invoice.component';

const routes: Routes = [
  {
    path: '',
    component: PublicOrderComponent
  },
  {
    path: 'store',
    component: StoreInvoiceComponent
  }
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MntPublicOrderRoutingModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-public-order/mnt-public-order-routing.module.ts